module.exports = __webpack_public_path__ + "static/media/disabledUploadIcon.b42b0016.svg";